import { Direction, SnellenSize, TumblingEObject, TumblingEStatus } from "types/testTypes";

export const TumblingECharList: TumblingEObject[] = [
  {
    _id: "row_0_col_0",
    order: 0,
    row: 0,
    column: 0,
    orientation: Direction.RIGHT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_200,
  },
  {
    _id: "row_1_col_0",
    order: 1,
    row: 1,
    column: 0,
    orientation: Direction.DOWN,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_100,
  },
  {
    _id: "row_1_col_1",
    order: 2,
    row: 1,
    column: 1,
    orientation: Direction.RIGHT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_100,
  },
  {
    _id: "row_2_col_0",
    order: 3,
    row: 2,
    column: 0,
    orientation: Direction.LEFT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_80,
  },
  {
    _id: "row_2_col_1",
    order: 4,
    row: 2,
    column: 1,
    orientation: Direction.UP,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_80,
  },
  {
    _id: "row_2_col_2",
    order: 5,
    row: 2,
    column: 2,
    orientation: Direction.DOWN,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_80,
  },
  {
    _id: "row_3_col_0",
    order: 6,
    row: 3,
    column: 0,
    orientation: Direction.RIGHT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_63,
  },
  {
    _id: "row_3_col_1",
    order: 7,
    row: 3,
    column: 1,
    orientation: Direction.UP,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_63,
  },
  {
    _id: "row_3_col_2",
    order: 8,
    row: 3,
    column: 2,
    orientation: Direction.LEFT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_63,
  },
  {
    _id: "row_3_col_3",
    order: 9,
    row: 3,
    column: 3,
    orientation: Direction.LEFT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_63,
  },
  {
    _id: "row_4_col_0",
    order: 10,
    row: 4,
    column: 0,
    orientation: Direction.LEFT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_50,
  },
  {
    _id: "row_4_col_1",
    order: 11,
    row: 4,
    column: 1,
    orientation: Direction.UP,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_50,
  },
  {
    _id: "row_4_col_2",
    order: 12,
    row: 4,
    column: 2,
    orientation: Direction.LEFT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_50,
  },
  {
    _id: "row_4_col_3",
    order: 13,
    row: 4,
    column: 3,
    orientation: Direction.RIGHT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_50,
  },
  {
    _id: "row_4_col_4",
    order: 14,
    row: 4,
    column: 4,
    orientation: Direction.DOWN,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_50,
  },
  {
    _id: "row_5_col_0",
    order: 15,
    row: 5,
    column: 0,
    orientation: Direction.DOWN,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_40,
  },
  {
    _id: "row_5_col_1",
    order: 16,
    row: 5,
    column: 1,
    orientation: Direction.LEFT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_40,
  },
  {
    _id: "row_5_col_2",
    order: 17,
    row: 5,
    column: 2,
    orientation: Direction.LEFT,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_40,
  },
  {
    _id: "row_5_col_3",
    order: 18,
    row: 5,
    column: 3,
    orientation: Direction.UP,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_40,
  },
  {
    _id: "row_5_col_4",
    order: 19,
    row: 5,
    column: 4,
    orientation: Direction.UP,
    status: TumblingEStatus.HIDDEN,
    snellenSize: SnellenSize.SIZE_20_40,
  },
  /*  {
      _id: "row_6_col_0",
      order: 20,
      row: 6,
      column: 0,
      orientation: Orientation.RIGHT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_32,
    },
    {
      _id: "row_6_col_1",
      order: 21,
      row: 6,
      column: 1,
      orientation: Orientation.LEFT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_32,
    },
    {
      _id: "row_6_col_2",
      order: 22,
      row: 6,
      column: 2,
      orientation: Orientation.UP,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_32,
    },
    {
      _id: "row_6_col_3",
      order: 23,
      row: 6,
      column: 3,
      orientation: Orientation.UP,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_32,
    },
    {
      _id: "row_6_col_4",
      order: 24,
      row: 6,
      column: 4,
      orientation: Orientation.DOWN,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_32,
    },
    {
      _id: "row_6_col_5",
      order: 25,
      row: 6,
      column: 5,
      orientation: Orientation.RIGHT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_32,
    },
    {
      _id: "row_6_col_6",
      order: 26,
      row: 6,
      column: 6,
      orientation: Orientation.LEFT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_32,
    },
    {
      _id: "row_7_col_0",
      order: 27,
      row: 7,
      column: 0,
      orientation: Orientation.UP,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_25,
    },
    {
      _id: "row_7_col_1",
      order: 28,
      row: 7,
      column: 1,
      orientation: Orientation.LEFT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_25,
    },
    {
      _id: "row_7_col_2",
      order: 29,
      row: 7,
      column: 2,
      orientation: Orientation.DOWN,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_25,
    },
    {
      _id: "row_7_col_3",
      order: 30,
      row: 7,
      column: 3,
      orientation: Orientation.UP,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_25,
    },
    {
      _id: "row_7_col_4",
      order: 31,
      row: 7,
      column: 4,
      orientation: Orientation.LEFT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_25,
    },
    {
      _id: "row_7_col_5",
      order: 32,
      row: 7,
      column: 5,
      orientation: Orientation.DOWN,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_25,
    },
    {
      _id: "row_7_col_6",
      order: 33,
      row: 7,
      column: 6,
      orientation: Orientation.UP,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_25,
    },
    {
      _id: "row_7_col_7",
      order: 34,
      row: 7,
      column: 7,
      orientation: Orientation.LEFT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_25,
    },
    {
      _id: "row_8_col_0",
      order: 35,
      row: 8,
      column: 0,
      orientation: Orientation.LEFT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_20,
    },
    {
      _id: "row_8_col_1",
      order: 36,
      row: 8,
      column: 1,
      orientation: Orientation.DOWN,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_20,
    },
    {
      _id: "row_8_col_2",
      order: 37,
      row: 8,
      column: 2,
      orientation: Orientation.UP,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_20,
    },
    {
      _id: "row_8_col_3",
      order: 38,
      row: 8,
      column: 3,
      orientation: Orientation.LEFT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_20,
    },
    {
      _id: "row_8_col_4",
      order: 39,
      row: 8,
      column: 4,
      orientation: Orientation.RIGHT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_20,
    },
    {
      _id: "row_8_col_5",
      order: 40,
      row: 8,
      column: 5,
      orientation: Orientation.DOWN,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_20,
    },
    {
      _id: "row_8_col_6",
      order: 41,
      row: 8,
      column: 6,
      orientation: Orientation.UP,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_20,
    },
    {
      _id: "row_8_col_7",
      order: 42,
      row: 8,
      column: 7,
      orientation: Orientation.LEFT,
      status: TumblingEStatus.HIDDEN,
      snellenSize: SnellenSize.SIZE_20_20,
    },*/
];
